import { WuiDateRangeInput as _WuiDateRangeInput, WuiDateRangeInputWithPresets as _WuiDateRangeInputWithPresets, WuiIcon as _WuiIcon, } from './components';
import { PUBLIC_UTILS } from './public-utils';
/**
 * Add extra meta to component
 */
function extend(component, extra) {
    Object.keys(extra).forEach((key) => {
        component[key] = extra[key];
    });
    return component;
}
export const WuiDateRangeInput = extend(_WuiDateRangeInput, {
    stringifyValue: PUBLIC_UTILS.Components.DateRangeInput.stringifyValue,
    parseValue: PUBLIC_UTILS.Components.DateRangeInput.parseValue,
});
export const WuiDateRangeInputWithPresets = extend(_WuiDateRangeInputWithPresets, {
    PRESETS: PUBLIC_UTILS.Components.DateRangeInputWithPresets.PRESETS,
});
export const WuiIcon = extend(_WuiIcon, {
    ICON_NAMES: PUBLIC_UTILS.Components.Icon.ICON_NAMES,
});
